import { Grid, Box, Card, Typography } from '@mui/material';
import { useState } from 'react';
import { ICvViewAnalytics, IJobCandidateInteraction } from 'wisestep-api';
import {
  getCurrentZoneAbbr,
  getCurrentZoneAbbrInHour,
  getCurrentZoneAbbrInMinute,
  WsColors,
} from 'wisestep-base';

import MappingsByRecruiter from '../../..//features/analytics/components/JobsCRMAnalytics/MappingsByRecruiter';
import SubmissionsByRecruiter from '../../..//features/analytics/components/JobsCRMAnalytics/SubmissionsByRecruiter';
import ApplicationInsightsContainer from '../../../features/analytics/components/JobsCRMAnalytics/ApplicationInsights/ApplicationInsightsContainer';
import JobCrmAiSuggestionMappedCandidates from '../../../features/analytics/components/JobsCRMAnalytics/JobCrmAiSuggestionMappedCandidates';
import JobCrmAiSuggestionMappedCandidatesByRecruiters from '../../../features/analytics/components/JobsCRMAnalytics/JobCrmAiSuggestionMappedCandidatesByRecruiters';
import JobCrmAiSuggestionViewedCandidates from '../../../features/analytics/components/JobsCRMAnalytics/JobCrmAiSuggestionViewedCandidates';
import JobCrmAiSuggestionViewedCandidatesByRecruiters from '../../../features/analytics/components/JobsCRMAnalytics/JobCrmAiSuggestionViewedCandidatesByRecruiters';
import JobCRMCountsChart from '../../../features/analytics/components/JobsCRMAnalytics/JobCRMCountsChart';
import JobsCrmSMSSentAnalytics from '../../../features/analytics/components/JobsCRMAnalytics/JobsCrmSMSSentAnalytics';
import JobsCrmSMSSentByAnalytics from '../../../features/analytics/components/JobsCRMAnalytics/JobsCrmSMSSentByAnalytics';
import MappingsBySourcePieChart from '../../../features/analytics/components/JobsCRMAnalytics/MappingsBySourcePieChart';
import SpecificJobPipelineData from '../../../features/analytics/components/JobsCRMAnalytics/SpecificJobPipelineData';
import SubmissionsBySourcePieChart from '../../../features/analytics/components/JobsCRMAnalytics/SubmissionsBySourcePieChart';
import TimeToServiceJobsCRM from '../../../features/analytics/components/JobsCRMAnalytics/TimeToServiceJobsCRM';
import TimeToServiceJobStage from '../../../features/analytics/components/JobsCRMAnalytics/TimeToServiceJobStage';
import TurnAroundTimeByStagesTable from '../../../features/analytics/components/JobsCRMAnalytics/TurnAroundTimeByStagesTable';
import TurnAroundTimeByStageAnalytics from '../../analytics/components/JobsCRMAnalytics/TurnAroundTimeByStageAnalytics';

type JobCRMPageParams = {
  jobId: string;
  jobCode?: string;
};
const JobCrmAnalytics = ({ jobId, jobCode = '' }: JobCRMPageParams) => {
  const [payload] = useState<IJobCandidateInteraction>({
    jobCode: jobCode,
    jobId: jobId,
    utcOffset: getCurrentZoneAbbr(),
    utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
    utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
    page: 0,
  });
  const payloadForCvView: ICvViewAnalytics = {
    jobCode: jobCode,
    jobId: jobId,
    utcOffset: getCurrentZoneAbbr(),
    utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
    utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
  };

  return (
    <Box>
      <Grid px={2} py={2} container>
        <Grid bgcolor={WsColors.White} mt={2} item xs={12} padding={2}>
          <Grid pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={12}>
              <JobCRMCountsChart payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={12}>
              <SpecificJobPipelineData payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={12}>
              <MappingsBySourcePieChart payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={12}>
              <SubmissionsBySourcePieChart payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={6}>
              <MappingsByRecruiter payload={payload} />
            </Grid>
            <Grid item xs={6}>
              <SubmissionsByRecruiter payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={6}>
              <JobsCrmSMSSentAnalytics payload={payload} />
            </Grid>
            <Grid item xs={6}>
              <JobsCrmSMSSentByAnalytics payload={payload} />
            </Grid>
          </Grid>
          <Grid mt={2} pb={2} container item xs={12} direction={'row'} spacing={2}>
            <Grid item xs={6}>
              <TimeToServiceJobStage payload={payload} />
            </Grid>
            <Grid item xs={6}>
              <TimeToServiceJobsCRM payload={payload} />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TurnAroundTimeByStageAnalytics jobId={jobId} />
          </Grid>
          <Grid item xs={12}>
            <TurnAroundTimeByStagesTable jobId={jobId} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Card sx={{ minHeight: 100, m: 2 }}>
            <Grid xs={12} py={4} textAlign={'center'}>
              <Typography variant="h4">AI Matching Usage</Typography>
            </Grid>
          </Card>
        </Grid>
        <Grid bgcolor={WsColors.White} item xs={12} padding={2}>
          <Grid container xs={12} mt={2} direction={'row'} justifyContent={'center'} display="flex">
            <Grid item xs={6}>
              <JobCrmAiSuggestionViewedCandidates payload={payloadForCvView} />
            </Grid>
            {/* <Grid item xs={4}>
              <JobCrmAiSuggestionSubmittedCandidates payload={payload} />
            </Grid> */}
            <Grid item xs={6}>
              <JobCrmAiSuggestionMappedCandidates payload={payload} />
            </Grid>
          </Grid>
          <Grid pb={2} container item xs={12} direction={'row'} spacing={2} mt={2}>
            <Grid item xs={6}>
              <JobCrmAiSuggestionViewedCandidatesByRecruiters payload={payloadForCvView} />
            </Grid>
            <Grid item xs={6}>
              <JobCrmAiSuggestionMappedCandidatesByRecruiters payload={payload} />
            </Grid>
          </Grid>
        </Grid>
        <>
          <Grid item xs={12}>
            <Card
              sx={{
                minHeight: 100,
                m: 2,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" m="auto">
                Application Insights
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <ApplicationInsightsContainer query={payload} />
          </Grid>
        </>
      </Grid>
    </Box>
  );
};

export default JobCrmAnalytics;
